import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryFilter from './components/CategoryFilter';
import ArticlesGrid from './components/ArticlesGrid';
import HealthTips from './components/HealthTips';

export default function WellnessBlog() {
  const [selectedCategory, setSelectedCategory] = useState('All');

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <CategoryFilter selectedCategory={selectedCategory} onSelectCategory={setSelectedCategory} />
      <ArticlesGrid selectedCategory={selectedCategory} />
      <HealthTips />
      <Footer />
    </div>
  );
}
